import { Box, IconButton, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState, useContext, useEffect, useRef } from "react";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import PropTypes from 'prop-types';
import React from "react";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { GlobalStateContext } from '../store/GlobalState';
import { useNavigate } from "react-router-dom";
import '../assets/css/Main.css'
import {
  DateContainer, GreenButton, RedButton, TransparentButton,
} from "../assets/style"
import ToDoListContainer from "../components/Containers/ToDoListContainer";
import RemainingWorkContainer from "../components/Containers/RemainingWorkContainer";
import { useLazyGetUsersQuery } from "../features/users/usersApiSlice";
import { HrproStaff } from "../components/models/HrproStaff";
import { useLogoutMutation, useRefreshTokenMutation } from "../features/auth/authApiSlice";
import { useDispatch } from "react-redux";
import { setCredentials } from "../features/auth/authSlice";
import MainContent from "./MainContent";
import NGContainer from '../components/Containers/NGContainer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
function TablePaginationActions(props: any) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;



  const handleFirstPageButtonClick = (event: any) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: any) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: any) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: any) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


const Main = () => {
  const [datePickerValue, setDatePickerValue] = React.useState<Dayjs | null>(dayjs(new Date()));
  const globalState = useContext(GlobalStateContext);
  const navigate = useNavigate();
  const [user, setUser] = React.useState<HrproStaff>();
  const [getUsersQuery, { data: users, error, isLoading, }] = useLazyGetUsersQuery();
  const [refreshToken] = useRefreshTokenMutation();
  const dispatch = useDispatch();
  const [errMsg, setErrMsg] = useState('')
  const errRef = useRef<HTMLInputElement>(null);
  const [refreshTodoListCounter, setRefreshTodoListCounter] = useState(0)
  const [showNG, setShowNG] = useState(true);
  const handleShowNGButton = async () => {
    setShowNG(!showNG);
  }

  const fetchUserEndpointJson = async () => {
    try {
      if (globalState.token) {
        //await
        getUsersQuery()
          .then((data: any) => {
            if (data.error) {
              // alert('Your session has timed out. Please login again.');
              // localStorage.setItem('token', '');
              // globalState.setToken('');
              // navigate("/");
              handleRefreshToken();
              window.location.reload();
            }
          });

        const _user = users;
        setUser(_user);
      }
    } catch (err) {
      alert('An error occurred. Please refresh and login again.');
      localStorage.setItem('token', '');
      globalState.setToken('');
      navigate("/");
      window.location.reload();
    }
  }

  useEffect(() => {
    // console.log("effect in main")
    const storedToken = localStorage.getItem('token');
    if (storedToken == "") {
      navigate("/");
      return; // not needed to fetch data
    }
    globalState.setToken(storedToken);

    if (globalState.token === "") {
      navigate("/");
      return; // not needed to fetch data
    }

    if (user == null && !isLoading && !error) {
      fetchUserEndpointJson().catch(() => {
        navigate("/");
      });
    }

    const intervalId = setInterval(async () => {
      await handleRefreshToken();
    }, 1814400000); // 15 minutes in milliseconds 1814400000

    return () => {
      clearInterval(intervalId);
    };
  }, [users, user, globalState.token]);

  const handleRefreshToken = async () => {
    try {
      // const authorization = `Bearer ${globalState.token}`
      // const userData = await refreshToken({ authorization }).unwrap()

      localStorage.setItem('token', '');
      globalState.setToken('');

      refreshToken({ user }).unwrap().then((userData) => {
        dispatch(setCredentials({ user: user, accessToken: userData }))
        localStorage.setItem('token', userData)
        globalState.setToken(userData)
        navigate('/main')
      });
      // const userData = await refreshToken({ user }).unwrap()
      // dispatch(setCredentials({ user: user, accessToken: userData }))
      // localStorage.setItem('token', userData)
      // await globalState.setToken(userData)
      // navigate('/main')
    } catch (err) {
      // console.log('hehe')
      if (!err?.originalStatus) {
        setErrMsg('No Server Response');
      } else if (err.originalStatus === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.originalStatus === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Refresh Failed');
      }
      errRef.current?.focus();
      console.log(errMsg);
      navigate('/')
    }
  }

  const handlePreviousDay = () => {
    var previousDay = datePickerValue;
    var newDay = previousDay?.subtract(1, 'day');
    setDatePickerValue(dayjs(newDay));
  };

  const handleNextDay = () => {
    var nextDay = datePickerValue;
    var newDay = nextDay?.add(1, 'day');
    setDatePickerValue(dayjs(newDay));
  };

  return (

    <div>
      <MainContent style={{ zIndex: 1 }} type={"main"}>
        {/* <BackgroundContainer sx={{ zIndex: 0, marginLeft: showSidebar ? '250px' : '0px' }}> */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <DateContainer className="date-picker-overide-styles">
            <IconButton onClick={handlePreviousDay} aria-label="Previous">
              <ArrowLeftIcon />
            </IconButton>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  label="Date Picker"
                  value={datePickerValue}
                  onChange={(newValue: any) => setDatePickerValue(newValue)}
                  //disableFuture
                  maxDate={dayjs().add(7, 'day')}
                  minDate={dayjs().subtract(365, 'day')}
                  format="DD/MM/YYYY"
                />
              </DemoContainer>
            </LocalizationProvider>
            <IconButton onClick={handleNextDay} aria-label="next" disabled={datePickerValue! > dayjs(new Date()).subtract(1 - 7, 'day')}>
              <ArrowRightIcon />
            </IconButton>
          </DateContainer>
          {showNG &&
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <IconButton
                onClick={handleShowNGButton}
                sx={{ color: '#FFFFFF' }}
              >
                <NavigateNextIcon />
              </IconButton>
            </div>
          }
          {!showNG &&
            <IconButton
              onClick={handleShowNGButton}
              sx={{ color: '#FFFFFF' }}
            >
              <NavigateBeforeIcon />
            </IconButton>
          }
        </div>

        {/* Grids For Test*/}
        <Grid container spacing={1.5}>
          {showNG &&
            <>
              <Grid item md={6} xs={12}>
                {/* <ToDoListContainer date={dayjs("2023-10-21")}></ToDoListContainer> */}
                <ToDoListContainer date={datePickerValue} refreshTodoListCounter={refreshTodoListCounter}></ToDoListContainer>
              </Grid>
              <Grid item md={6} xs={12}>
                <NGContainer date={datePickerValue} userSurName={user?.surName} userOtherName={user?.otherName} staffId={user?.eeNo} />
              </Grid>
            </>
          }
          {!showNG &&
            <Grid item md={12} xs={12}>
              {/* <ToDoListContainer date={dayjs("2023-10-21")}></ToDoListContainer> */}
              <ToDoListContainer date={datePickerValue} refreshTodoListCounter={refreshTodoListCounter}></ToDoListContainer>
            </Grid>
          }
          {/* <Grid item md={12} xs={12}>
            <RemainingWorkContainer date={datePickerValue} staffId={user?.eeNo} setRefreshTodoListCounter={setRefreshTodoListCounter} refreshTodoListCounter={refreshTodoListCounter} />
          </Grid> */}

          <Grid item md={12} xs={12}>
            <RemainingWorkContainer date={datePickerValue} staffId={user?.eeNo} setRefreshTodoListCounter={setRefreshTodoListCounter} refreshTodoListCounter={refreshTodoListCounter} />
          </Grid>

        </Grid>
      </MainContent>
    </div>
  );
}
export default Main;